// Copyright (c) Zammo Inc.

import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { Voice } from '../../app/actions';
import Button from '../buttons/Button';
import Modal from '../Modals/Modal';

import VoicePicker from './VoicePicker';

const Container = styled.div`
  font-size: 1rem;

  > div {
    margin-bottom: 1rem;
    line-height: 1.5;
  }
`;

interface Props {
  isOpen: boolean;
  selectedVoice: string;
  allVoices: Voice[];
  onClose: () => void;
  setSelectedVoice: (value: string) => void;
}
function VoiceSettingModal({ isOpen, selectedVoice, allVoices, setSelectedVoice, onClose }: Props) {
  const [voicePickerSelectedVoice, setVoicePickerSelectedVoice] = useState<string>(selectedVoice);

  useEffect(() => {
    setVoicePickerSelectedVoice(selectedVoice);
  }, [selectedVoice]);

  const handleSubmit = () => {
    setSelectedVoice(voicePickerSelectedVoice);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} showCloseButton>
      <Container>
        <div>The voice you select below will be used to read the incoming but messages.</div>
        <div>The language will be adjusted based on the incoming language from the bot.</div>
        <VoicePicker
          allVoices={allVoices}
          selectedVoice={voicePickerSelectedVoice}
          setSelectedVoice={setVoicePickerSelectedVoice}
        />
      </Container>
      <div style={{ textAlign: 'center', marginTop: '1rem' }}>
        <Button
          type="button"
          onClick={handleSubmit}
          style={{ display: 'block', maxWidth: '300px', width: '100%', margin: '2rem auto 0' }}
        >
          Set
        </Button>
      </div>
    </Modal>
  );
}

export default VoiceSettingModal;
